import { render } from "./TypeList.vue?vue&type=template&id=3eb8415a"
import script from "./TypeList.vue?vue&type=script&setup=true&lang=js"
export * from "./TypeList.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Playbooks/Admin/TypeList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3eb8415a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3eb8415a', __exports__)) {
    api.reload('3eb8415a', __exports__)
  }
  
  module.hot.accept("./TypeList.vue?vue&type=template&id=3eb8415a", () => {
    api.rerender('3eb8415a', render)
  })

}


export default __exports__